import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIList from 'UIComponents/list/UIList';
import styled from 'styled-components';
import { Step } from 'signup-constants/Step';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "HubletExpandableSubTitleSection__StyledFormattedMessage",
  componentId: "sc-1s7744b-0"
})(["font-size:16px;"]);
const StyledExpandableSection = styled.div.withConfig({
  displayName: "HubletExpandableSubTitleSection__StyledExpandableSection",
  componentId: "sc-1s7744b-1"
})(["text-align:left;"]);
export const HubletExpandableSubTitleSection = ({
  titleKey = `views.${Step.HubletSelection}.expandableSubTitleSection.title`
}) => {
  return /*#__PURE__*/_jsx(StyledExpandableSection, {
    children: /*#__PURE__*/_jsx(UIAccordionItem, {
      title: I18n.text(titleKey),
      children: /*#__PURE__*/_jsxs(UIList, {
        childClassName: "m-bottom-1",
        styled: true,
        children: [/*#__PURE__*/_jsx(StyledFormattedMessage, {
          message: `views.${Step.HubletSelection}.expandableSubTitleSection.bulletpointOne`
        }), /*#__PURE__*/_jsx(StyledFormattedMessage, {
          message: `views.${Step.HubletSelection}.expandableSubTitleSection.bulletpointTwo`
        }), /*#__PURE__*/_jsx(StyledFormattedMessage, {
          message: `views.${Step.HubletSelection}.expandableSubTitleSection.bulletpointThree`
        })]
      })
    })
  });
};
export default HubletExpandableSubTitleSection;